import React from 'react';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const Icon = styled.svg`
  g {
    transform-origin: 50% 50%;
    .active &,
    .idle & {
      animation: ${spin} 5s linear infinite;
    }
  }
  .cls-1 {
    fill: none;
    stroke: #fff;
    stroke-width: 2px;
  }
`;

export const UtilitiesIcon = () => {
  return (
    <Icon viewBox='0 0 72 72'>
      <g id='utilities-icon'>
        <path
          id='Path-5'
          className='cls-1'
          d='M36.64,1c5.54,0,4.88,4.55,11.09,7.23s9-1.17,13.31,3.33,1.16,8.53,3.44,14.14S71,30.87,71,36.1,67.16,40,64.48,46.56s.66,9.67-3.44,14-7.37,1-13.31,3.56S42.15,71,36.64,71s-4.56-4.19-11-6.92-9.48.42-13.72-3.56,1.25-8-1.5-14.11S1,41.65,1,36.1s4.33-4.69,7.15-11-.63-9.3,3.76-13.52,7.75-.78,13.72-3.33S31.1,1,36.64,1Z'
        />
      </g>
    </Icon>
  );
};
